export enum RefundType {
  entire = 'ENTIRE',
  partial = 'PARTIAL',
}
